module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h3', {
    staticClass: "cn"
  }, [_c('a', {
    attrs: {
      "id": "page_33"
    }
  }), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter Three")])]), _vm._v(" "), _c('h3', {
    staticClass: "ct"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("SHINING BRASS")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f0033-1.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/37_Glossary#Bglo60",
      "id": "Aglo60",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Recon Team")]), _vm._v(" Dakota, aboard an H-34, about to be inserted in Laos. (Photo provided by Jason Woodworth)")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "dcap"
  }, [_vm._v("W")]), _c('span', {
    staticClass: "small"
  }, [_vm._v("ITH THE ARRIVAL OF")]), _vm._v(" U.S. "), _c('span', {
    staticClass: "small"
  }, [_vm._v("COMBAT")]), _vm._v(" troops in 1965, there grew a parallel need for detailed, reliable intelligence about enemy activities beyond the borders of South Vietnam. Thus, on 7 March 1965, one day before the first U.S. Marine Corps ground units waded ashore at Danang, SOG was assigned the responsibility for cross-border intelligence gathering.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Inside SOG, this new strategic reconnaissance project was code-named "), _c('span', {
    attrs: {
      "href": "#/xhtml/37_Glossary#Bglo64",
      "id": "Aglo64",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Shining Brass")]), _vm._v(", under which small teams of six or eight indigenous soldiers led by U.S. Green Berets would infiltrate Laos to unravel the mysteries of the Ho Chi Minh Trail.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Overseeing SOG would be a new chief, a truly legendary Special Forces officer, Col. Donald “Headhunter” Blackburn, famous as a Philippine guerrilla leader in World War II. When the Japanese overran the Philippines in 1942, 25-year-old Capt. Don Blackburn refused to surrender, evading deep into the jungle, where he recruited and trained a force of Igarote tribesmen—former headhunters who soon were nicknamed “Blackburn’s Headhunters.” By the time Douglas McArthur returned in 1944, Blackburn commanded 20,000 guerrillas and wore the eagles of a full colonel—the youngest one in the U.S. Army. Blackburn’s World War II exploits were lionized in a 1955 book, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Blackburn’s Headhunters")]), _vm._v(", which Hollywood later turned into a motion picture.")]), _vm._v(" "), _c('p', {
    staticClass: "head1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("RECON IN LAOS")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Colonel Blackburn could think of but one Special Forces officer to head Project Shining Brass, the stout-shouldered Col. Arthur D. “Bull” Simons. “He was all business,” recalls Colonel Blackburn. “He wasn’t one who showed much frivolity in "), _c('a', {
    attrs: {
      "id": "page_34"
    }
  }), _vm._v("anything. A real disciplinarian, but he showed good judgment and common sense.” During World War II, Bull Simons’ 6th Ranger battalion was the eyes and ears of the 11th Airborne Division and led the way ashore at Leyte. Simons spent the Korean War as an instructor at the Ranger Training Center, where he taught hand-to-hand combat and close-quarters shooting.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f0034-1.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("Chief SOG, 1965–66, Col. Don Blackburn displays the elephant tusk presented to him by the recon man who killed one to prove that the NVA were using them as beasts of burden. (See story on "), _c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter4#page_53",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("p. 53")]), _vm._v(".) (Photo provided by John Plaster)")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Providing the men for Shining Brass was the 1st SFG on Okinawa, whose Green Beret recon volunteers began intense training that summer of 1965 in Okinawa’s Northern Training Area. By late summer, 16 volunteers were left, exactly the number required to man five U.S.-led recon teams, with one man to spare. Arriving in Vietnam, they were mated with their native teammates. At the start, SOG’s indigenous troops were all "), _c('span', {
    attrs: {
      "href": "#/xhtml/37_Glossary#Bglo47",
      "id": "Aglo47",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Nungs")]), _vm._v(", who’d emigrated from southern China, but as SOG grew and casualties mounted, indigenous ranks would include Vietnamese civilians, Montagnard hill tribesmen, and even former NVA soldiers.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As quickly as President Johnson approved Shining Brass, the U.S. ambassador to Laos added his own rules of engagement, limiting Blackburn’s recon area to just two “boxes” 6 miles deep and 12 miles long. Combined, they covered only 24 miles of the 200-mile Laotian border.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("To support its cross-border activities, Shining Brass needed a forward operating base ("), _c('span', {
    attrs: {
      "href": "#/xhtml/37_Glossary#Bglo28",
      "id": "Aglo28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("FOB")]), _vm._v(") near the Laotian frontier, where recon teams would live and helicopters could refuel and rearm. Colonel Simons decided to put the FOB at the Kham Duc Special Forces Camp, 60 miles southwest of Danang, an isolated, lonely outpost unvisited by nosy reporters. Although this made for good security, chronically bad weather and poor living conditions left much to desire. “It was miserable,” recalls a Special Forces noncommissioned officer (NCO) who served there.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("To direct the SOG missions launched from Kham Duc, Bull Simons recruited one of the most remarkable officers in Special Forces, a Finnish-American captain, Larry Thorne.")]), _vm._v(" "), _c('p', {
    staticClass: "head1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("ONE-ZERO")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("By early fall of 1965, SOG’s first five U.S.-led recon teams (RTs)—named for the states Iowa, Alaska, Idaho, Kansas, and Dakota—were at Kham Duc finishing training under the guidance of their Green Beret team leaders, whose command position was code-numbered “"), _c('span', {
    attrs: {
      "href": "#/xhtml/37_Glossary#Bglo51",
      "id": "Aglo51",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("One-Zero")]), _vm._v(".”")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f0034-2.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("Heading SOG’s Shining Brass recon on Ho Chi Minh Trail, Col. Arthur “Bull” Simons prepares for a practice parachute jump from a SOG H-34 “"), _c('span', {
    attrs: {
      "href": "#/xhtml/37_Glossary#Bglo37",
      "id": "Aglo37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Kingbee")]), _vm._v(".” (Photo provided by the George K. Sisler family)")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_35"
    }
  }), _vm._v("The One-Zero recon team leader became SOG’s most prestigious title. Any man appointed a One-Zero had proven his judgment under life-and-death stress, displayed personal bravery, and acquired hazardously gained tactical expertise. Each One-Zero recruited and trained his own indigenous soldiers, chose however he thought best to arm and equip them, and possessed amazing latitude in planning operations. Throughout SOG, One-Zeros would be held in a respect that verged on awe, because once on the ground, this was the lone commander who must outwit everything the enemy could throw at his team—from trackers and ambushers to pursuers by the hundreds or even thousands.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The One-Zero’s other two Green Berets also received code numbers, the assistant team leader becoming the “"), _c('span', {
    attrs: {
      "href": "#/xhtml/37_Glossary#Bglo49",
      "id": "Aglo49",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("One-One")]), _vm._v(",” and the radio operator the team “"), _c('span', {
    attrs: {
      "href": "#/xhtml/37_Glossary#Bglo50",
      "id": "Aglo50",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("One-Two")]), _vm._v(".”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("One-Zero for SOG’s first cross-border operation was M. Sgt. Charles “Slats” Petry, whose team, RT Iowa, included seven Nungs, one ARVN lieutenant, and a One-One, Sfc. Willie Card. For deniability, RT Iowa was “sterile”—they wore no rank or unit insignia, and even their uniforms and rucksacks were untraceably Asian made. For weapons, they carried Carl Gustav Model 1945 9mm submachine guns—Swedish Ks—and Belgian-made Browning 9mm pistols. If captured, the men were to claim that they’d stumbled into Laos while looking for a missing C-123 and had no idea they’d crossed the border.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('p', {
    staticClass: "grhd"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("LAOS AREA OF OPERATIONS")])]), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f0035-1.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_36"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f0036-1.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("Patches of CCN, CCC, and CCS.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Petry and RT Iowa were briefed extensively. Although Hanoi denied having a single soldier in Laos, by October 1965 its security, engineer, and logistics troops numbered at least 30,000, plus an additional 4,500 men passing through each month en route to South Vietnam. About 200 truckloads of supplies rolled down the Trail monthly, and by late 1965, the U.S. Air Force already knew the enemy had spun its 900-mile road system the length of Laos to Vietnam’s Central Highlands.")]), _vm._v(" "), _c('p', {
    staticClass: "head1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("THE FIRST MISSION")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("RT Iowa’s objective was designated Target D-1, about 20 miles northwest of Kham Duc, where Laotian Highway 165 almost reached the South Vietnamese border. U.S. intelligence believed the NVA were infiltrating troops and carrying supplies through D-1 for attacks on Danang and Chu Lai. Far beyond the range of any U.S. artillery, if Petry and his men got into trouble they’d depend upon Thai-based F-105 fighter-bombers for fire support.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("On Monday, 18 October, while the 1st Air Cavalry Division fought the war’s first major U.S. engagement in the Ia Drang Valley, RT Iowa’s men stood beside the airstrip at Kham Duc, opened their rucksacks, and emptied their pockets for a final inspection to ensure they carried nothing attributable to the United States. The two Americans turned in their dogtags, military ID cards, and Geneva Convention cards and wallets. If their bodies were put on display, there was no way to prove they were Americans.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("They planned to land at last light so it would be dark before the NVA could send a reaction force or trackers after them, giving Petry’s men at least a full night’s head start. At 6:00 p.m. Captain Thorne wished Petry good luck and waved RT Iowa to three unmarked H-34 “Kingbee” helicopters, which cranked engines and then lifted away. RT Iowa rode the first bird, while Captain Thorne rode aboard the second of three Kingbees. Over Laos the weather proved especially hazardous, and they began taking .50-caliber machine gun fire, but the Kingbees took no hits.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Soon they met the forward air controller ("), _c('span', {
    attrs: {
      "href": "#/xhtml/37_Glossary#Bglo22",
      "id": "Aglo22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("FAC")]), _vm._v("), a tiny O-1 spotter plane flown by U.S. Air Force Maj. Harley Pyles, with a SOG air liaison officer, U.S. Marine Corps Capt. Winfield Sisson, in the backseat. Minutes later, the H-34s went in a downward spiral and then roared away, and it was done: SOG’s first American-led team had landed in Laos. In case Petry’s team ran into trouble, Captain Thorne kept his Kingbee overhead, sending the other helicopters back to Kham Duc. Soon, Petry radioed an “OK,” and then Thorne radioed Kham Duc that he, too, was headed back.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Finnish-American’s H-34 did not return, and Larry Thorne was never seen again. Then the FAC’s O-1 Bird Dog lifted off for Danang airbase with U.S. Air Force Major Pyles and U.S. Marine Corps Captain Sisson aboard. They, too, disappeared. In its first day, Shining Brass had generated three people missing in action (MIA).")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Meanwhile, beneath heavy overcast and drizzle, RT Iowa found Target D-1 crawling with NVA, but the enemy was preoccupied with his own labors and at first Petry had an easy go of it.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("On the third day, Petry heard truck engines so he maneuvered RT Iowa to investigate—and they bumped head-on into an NVA patrol. In the quick exchange of fire RT Iowa’s Nung point man collapsed, mortally wounded, and the chase was on. The North Vietnamese fanned out, searching high and low for them.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Two days later the weather broke, and RT Iowa struck back with 37 sorties of F-105 fighter-bombers before the Kingbees lifted them out. Then Petry went back with a FAC and called in an additional 51 sorties on targets he’d discovered, touching off “numerous” secondary explosions.")]), _vm._v(" "), _c('p', {
    staticClass: "head1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("MORE MISSIONS")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("SOG’s second Shining Brass operation proved as hazardous and productive as the first one.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_37"
    }
  }), _vm._v("Inserted on 2 November 1965 about 10 miles south from the first operation, RT Alaska searched for a hidden highway terminus just inside Laos. Led by M. Sgt. Dick Warren, One-Zero, with Sfc. David Kauhaahaa as his assistant, or One-One, and Sfc. Wilbur “Doc” Donaldson as One-Two packing the radio, RT Alaska found pretty much what the Saigon intelligence people had expected—a network of 5-foot-wide bicycle and foot trails coming in from nearby Laotian Highway 165, and patrols—lots of patrols—sweeping and searching for them.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("For three days, One-Zero Warren managed to bypass or hide from the enemy, but by the fourth day there were so many enemy that contact was inevitable. It came in a fast exchange of fire in which Alaska bettered the NVA, hitting several without any recon men being hit—then it was a footchase.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The gunfire drew dozens of NVA determined to run Warren’s men into the ground. When they paused on a hilltop for “Doc” Donaldson to radio a FAC, the North Vietnamese streamed up and spread out around them, trapping them in head-high elephant grass. The enemy hesitated to come into the grass, so they set it afire to push RT Alaska into the open.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Then a set of F-105s arrived and turned loose 20mm Vulcan cannons, but the NVA stood their ground. Without warning, a lone Kingbee roared right over the shooting NVA, and in 30 seconds RT Alaska was up and gone, with not one man wounded.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("One-Zero Warren went back with the FAC to direct 82 fighter-bomber sorties against targets RT Alaska had located, destroying a bridge and 36 buildings. By early December, RTs Kansas and Idaho, too, had run missions out of Kham Duc, and Shining Brass chief Bull Simons decided it was time to shift southward to the other “box” the ambassador had approved.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Relocating to the airstrip at Dak To in Vietnam’s Central Highlands, the SOG men began exploring areas along Highway 110 in far southern Laos. NVA soldiers were here in considerable strength, they found, and didn’t appreciate SOG’s intrusions into their heretofore sanctuaries.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("RT Kansas was hit so forcefully that the team split, and two Nungs disappeared. During the second operation, RT Idaho suffered the first U.S. recon casualty when one Green Beret was slightly wounded. But the teams were producing results.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f0037-1.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("When SOG’s original recon men began rotating out, Chief SOG Blackburn phoned Mrs. Billy Alexander at the Department of the Army personnel office to obtain top-quality Green Beret replacements. She enthusiastically supported Special Forces. (Photo provided by Steve Sherman)")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f0037-2.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("U.S. Ambassador to Laos William Sullivan often impeded or limited SOG operations. (Photo provided by Richard Shultz)")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("After each mission, the recon men were flown to SOG’s Saigon headquarters to debrief. It was during these Saigon debriefs that at last U.S. intelligence began to unravel the secrets of the Ho Chi Minh Trail.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("By the end of 1965, there had been eight Shining Brass penetrations of Laos, uncovering major North Vietnamese base camps, roads, and supply dumps. The cost? Two Nungs were missing, two more dead, several Nungs wounded, an H-34 Kingbee lost with its Vietnamese crew, one USAF O-1 Bird Dog missing with two U.S. aviators, and SOG’s first Special Forces MIA, Capt. Larry Thorne.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Having proven the value of its Shining Brass reconnaissance, Chief SOG Blackburn persuaded the ambassador in Laos to open the entire 200-mile frontier to the SOG recon teams but limited penetrations to 12 miles.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Meanwhile Blackburn found that his first generation of SOG recon volunteers were beginning to rotate to Okinawa and the States. Desperate to replace them with pick-of-the-litter Green Berets, Colonel Blackburn phoned the woman at the Pentagon who oversaw Special Forces overseas assignments, Mrs. Billy Alexander, and set up his own replacement pipeline. Thanks to Mrs. Alexander’s patriotic and unacknowledged support, throughout the war more than a few of the “cream” of the Green Berets reached SOG’s ranks, ensuring a qualitative edge for these most dangerous operations.")]), _vm._v(" "), _c('div', {
    staticClass: "bg2"
  }, [_c('a', {
    attrs: {
      "id": "page_38"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "bghd"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("LOST LEGEND: LARRY THORNE")])]), _vm._v(" "), _c('p', {
    staticClass: "s_noindent"
  }, [_vm._v("SOG’s first missing in action (MIA) in Laos, Larry Thorne, was lost on its initial Shining Brass cross-border operation and is missed to this day. To every man who ever worked with him, Capt. Larry Thorne was one of the most remarkable officers in Special Forces. Before Americanization, the legendary Finnish-American’s name was Lauri Torni, and it took only a few heavily accented words and one look at his lean, leathery face to see his Scandinavian roots. An unabashed smoker and drinker who disciplined himself into iron-hard physical condition, Thorne took delight in running into the ground soldiers half his age and displayed an infectious zest for life as a scuba diver, skydiver, boxer, skier, and first-class mountain climber.")]), _vm._v(" "), _c('p', {
    staticClass: "s_indent"
  }, [_vm._v("Thorne had first seen combat in 1940, when the Russians invaded his tiny Finnish homeland. At the hands of nimble Finnish ski troops who hit without warning and disappeared into the snowy landscape, the Soviets suffered astronomical casualties. Moscow forced a peace on the Finns, but a year later, when Germany invaded Russia, the Finns went back to war to recapture territory wrested away by Stalin. Thorne spent four years leading special reconnaissance and raiding parties behind Russian lines, inserting by parachute or boat or on skis. By 1945, Thorne’s expansive chest displayed every award his country could bestow, including three wound medals and Finland’s highest decoration, the Mannerheim Cross, awarded to him for an amazing convoy ambush that cost the Russians 300 dead with not one of Thorne’s men lost. Not only had the Germans awarded Thorne an Iron Cross, but selected him for advanced special operations training at an SS school. After Finland’s surrender, the Soviet-appointed occupation government twice arrested Thorne as an “enemy of the people,” but he escaped and made his way to the West.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f0038-1.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("Thorne in 1941 in a Waffen-SS uniform. Desperate for help in fighting the Russians, Finland sent 650 men to Germany for advanced training, not realizing that these honorable soldiers could later be depicted as Nazis. (Photo provided by H.A. Gill III)")])]), _vm._v(" "), _c('p', {
    staticClass: "s_indent"
  }, [_vm._v("Aware of Thorne’s impressive wartime record, former OSS chief “Wild Bill” Donovan personally interceded to get him U.S. residency and permission to enlist in the U.S. Army. Soon Thorne was commissioned a second lieutenant at Ft. Bragg and then sent to Europe with the 10th SFG.")]), _vm._v(" "), _c('p', {
    staticClass: "s_indent"
  }, [_vm._v("Maj. Robert Rheault, the 10th SFG’s S-3 operations officer, found Thorne “the finest soldier I’ve ever known.” He tapped his Finnish friend’s vast winter expertise to replace the U.S. Army’s outdated skis and ski doctrine. “We brought modern skiing into the United States Army despite the United States Army,” Rheault recalls.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f0038-2.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Momentous Day—18 October 1965. RT Iowa One, Zero Charles “Slats” Petry on Kham Duc airfield, for the launch of SOG’s first cross-border recon. Capt. Larry Thorne (left), who would disappear by nightfall, walks with Maj. Earl Emmons and is watched by Kingbee pilot “Cowboy” (right). (Photo provided by Ray Call)")])])]), _vm._v(" "), _c('p', {
    staticClass: "s_indent"
  }, [_c('a', {
    attrs: {
      "id": "page_39"
    }
  }), _vm._v("It was Rheault who dispatched Thorne and the 10th SFG’s Ski Committee to Iran’s highest glacier in 1963 to recover bodies from a crashed U.S. military transport. A European mountain rescue unit already had failed to reach the Zagros Mountains’ most formidable slope. Thorne and his men did the job so quickly that it seemed easy.")]), _vm._v(" "), _c('p', {
    staticClass: "s_indent"
  }, [_vm._v("By 1965, Rheault was in Vietnam as the 5th SFG’s executive officer and tried to give the 46-year-old Finn a desk job. “You’ve done enough fighting,” Rheault said. “You’ve got so much skill; we need you to train these young guys.” But the next thing Rheault knew, Thorne was back in the thick of it, as Bull Simons’ Shining Brass launch officer at Kham Duc.")]), _vm._v(" "), _c('p', {
    staticClass: "s_indent"
  }, [_vm._v("Unwilling to stay safely behind at Kham Duc, Thorne overflew the first Laos insertion aboard a Kingbee helicopter and then stayed above RT Iowa until they radioed they were safe. Then Thorne radioed that he, too, was headed back. He was never seen again.")]), _vm._v(" "), _c('p', {
    staticClass: "s_indent"
  }, [_vm._v("SOG aircraft overflew the valley for 30 days with negative results. Two years later a SOG team located the crash site and recovered the dead helicopter crewmen, but the Finn’s body was not in the wreckage. After Thorne’s status was switched from missing to likely dead, his stateside friends filled Ft. Bragg’s JFK Center Chapel for a memorial service, prominent among them his fellow Finnish-American Green Berets. After the eulogy and a poetry reading, the service closed with a delicate, emotional rendition of Sibelius’ “Finlandia,” chords that would touch the soul of a Finnish warrior like Thorne, no matter where he was.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f0039-1.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Larry Thorne began his military career as Lauri Torni, a Finnish commando whose exploits behind Russian lines resulted in the award of the Mannerheim Cross, Finland’s highest honor. (Photo provided by the Lindholm-Ventola family)")])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f0039-2.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("A winter operations expert, Thorne led a 1963 Special Forces mission to recover bodies from an aircraft crash high on an Iranian glacier. (Photo provided by Robert Rheault)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_40"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f0040-1.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("SOG’s first recon patch symbolized the dual missions of first finding intelligence and then, if the situation allowed, striking the enemy a mighty blow. (Photo provided by Jason Woodworth)")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f0040-2.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("Chinese Nung Recon Team. Note their “eyeball” recon patches. (Photo provided by Mecky Schuler)")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f0040-3.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("Kham Duc, the remote launch site for SOG’s first cross-border recons into Laos. (Photo provided by U.S. Air Force)")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_41"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f0041-1.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("All Smiles. RT Alaska is all smiles after being snatched to safety by SOG H-34 during the second Shining Brass mission. One-Zero Dick Warren (left), One-One David Kauhaahaa (behind Warren), and One-Two Wilbur “Doc” Donaldson had been surrounded by NVA. (Photo provided by Charlie Norton)")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_42"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f0042-1.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("For purposes of deniability, SOG teams initially carried untraceable Swedish K submachine guns. (Photo provided by Leonard Tilley)")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_43"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f0043-1.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("Displaying the High Morale of SOG recon. Leonard Tilley poses outside the RT Iowa team room he shared with One-Zero Jerry Wareing and Danny Jenkins, one of the few SEALs ever to run recon in SOG. (Photo provided by Leonard Tilley)")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f0043-2.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("One of SOG’s most accomplished team leaders, Richard “Dick” Meadows on a Laotian road, 1966.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f0043-3.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("Leonard Tilley, RT Iowa, in a Montagnard Village. Recon men recruited their own indigenous soldiers, whether they were Nungs, "), _c('span', {
    attrs: {
      "href": "#/xhtml/37_Glossary#Bglo78",
      "id": "Aglo78",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("’Yards")]), _vm._v(", or Vietnamese. (Photo provided by Leonard Tilley)")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c0ad5b9c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/11_Chapter3.vue
// module id = 93
// module chunks = 0